import { db } from '../main';
import { stage } from '../../appConfig'

const state =  {
	auth: false,
	user: null,
	token: null,
	role: null,
	date: null
};

const mutations = {
	SET_USER (state, payload) {
		state.user = payload;
	},
	SET_TOKEN (state, payload) {
        state.token = payload;
	},
	SET_AUTH (state, payload) {
	    state.auth = payload;
	},
	SET_ROLE (state, payload) {
	    state.role = payload;
	},
	SET_DATE (state, payload) {
	    state.date = payload;
	}
};

const actions = {
	setUser({commit}, payload){
		return new Promise((resolve, reject) => {
            db.collection("Users"+stage).doc(payload.uid).get().then(doc => {
                if(!doc.exists){
                    db.collection("Users"+stage).doc(payload.uid).set({
						uid: payload.uid,
                        email: payload.email,
						displayName: payload.displayName,
						fullName: "",
						firstName: "",
						middleName: "",
						lastName: "",
						tin: "",
                        photo: payload.photoURL,
						role: "admin",
						address: {
							brgy : "",
							city : "",
							state : ""
						},
						assign: "",
						countryCode: null,
						mobileNumber: "",
                    }).then(() => {
                        commit("SET_USER", payload);
                        resolve();
                    }).catch(error => {
                        reject(error);
                    });
                } else {
                    commit("SET_USER", doc.data());
                    resolve();
                }
			});
			
        })
	},

	setDate({commit}, payload){
		
		return new Promise((resolve, reject) => {
			if(payload) {
				commit("SET_DATE", payload);
				resolve();
			} else {
				reject();
			}
        });
	},

	setRole({commit}, payload){
		
		return new Promise((resolve, reject) => {
			if(payload) {
				commit("SET_ROLE", payload);
				resolve();
			} else {
				reject();
			}
        });
	},

	setToken({commit}, payload){
		return new Promise((resolve, reject) => {
			if(payload) {
				commit("SET_TOKEN", payload);
				resolve(payload);
			} else {
				reject();
			}
        });
	},
	setAuth({commit}, payload){
        return new Promise((resolve, reject) => {
			if(payload !== null) {
                commit("SET_AUTH", payload);
                if(!payload) {
                    commit("SET_TOKEN", null);
                    commit("SET_USER", null);
                    commit("SET_USER_ID", null);
                }
				resolve(payload);
			} else {
				reject();
			}
        });
	},

};

const getters = {
	auth: state => state.auth,
	user: state => state.user,
	userId: state => state.userId,
	token: state => state.token,
}

export default {
	state,
	mutations,
	actions,
	getters
};